import { useEffect, useState, createContext, useContext } from "react";
import { api } from "@/lib/api";

const Ctx = createContext({ status: {}, loading: true });

export function FeatureStatusProvider({ children }) {
    const [status, setStatus] = useState({});
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        api.get("/public/feature-status")
           .then(r => setStatus(r.data || {}))
           .catch(() => setStatus({}))
           .finally(() => setLoading(false));
    }, []);
    return <Ctx.Provider value={{ status, loading }}>{children}</Ctx.Provider>;
}

export function useFeatureStatus(key) {
    const { status } = useContext(Ctx);
    return key ? (status[key] || "coming_soon") : status;
}

const TONE = {
    live:        { label: "Live",        cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
    beta:        { label: "Beta",        cls: "bg-amber-50 text-amber-800 border-amber-200" },
    coming_soon: { label: "Coming Soon", cls: "bg-stone-100 text-stone-600 border-stone-200" },
};

export default function StatusPill({ featureKey, className = "" }) {
    const s = useFeatureStatus(featureKey);
    const meta = TONE[s] || TONE.coming_soon;
    return (
        <span className={`inline-flex items-center text-[10.5px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full border ${meta.cls} ${className}`}
              data-testid={`status-pill-${featureKey}`}>
            {meta.label}
        </span>
    );
}
